import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import HospitalizationDialog, {
  HospitalizationDialogCallbackInput,
  HospitalizationDialogInterfaceProps,
} from '../hospitalizations-dialog';

const { useDialogForContext, useDialog: useHospitalizationDialog } =
  getDialogHooks<
    HospitalizationDialogInterfaceProps,
    HospitalizationDialogCallbackInput
  >(HospitalizationDialog);
export const useHospitalizationDialogForContext = useDialogForContext;
export default useHospitalizationDialog;
